import { FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { BaseCheckbox, BaseFieldArray, BaseInput, FormBodyContainer } from 'wbs-components-lib';

import { getRewardItem, getRewardTypeSelectItems } from '@shared/utils';

import { VipLevelRewardFormProps } from './types';
import { vipTaskItemValidationSchema } from './validationSchema';

export const VipLevelRewardForm: FC<VipLevelRewardFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting = false,
  submitButtonCaption = 'Create',
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={vipTaskItemValidationSchema}
      enableReinitialize
    >
      {({ submitForm, values, handleChange, handleBlur, setFieldValue, errors, touched }) => {
        const {
          title: titleValue,
          reuseInterval: reuseIntervalValue,
          levelRewards: levelRewardsValue,
          isDisabled: isDisabledValue,
        } = values;
        const { title: titleError, reuseInterval: reuseIntervalError } = errors;
        const { title: isTitleTouched, reuseInterval: isReuseIntervalTouched } = touched;

        const onCasinoSubmit = async () => {
          await submitForm();
        };

        const isTitleError = isTitleTouched && !!titleError;
        const isReuseIntervalError = isReuseIntervalTouched && !!reuseIntervalError;

        const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

        return (
          <FormBodyContainer
            isSubmitting={isSubmitting}
            onSubmit={onCasinoSubmit}
            submitButtonCaption={submitButtonCaption}
            isSubmitButtonDisabled={isSubmitButtonDisabled}
          >
            <BaseInput
              helperText={isTitleError && titleError}
              label="Enter title"
              id="title"
              name="title"
              caption="Title"
              value={titleValue}
              onBlur={handleBlur}
              onChange={handleChange}
              error={isTitleError}
            />
            <BaseInput
              helperText={isReuseIntervalError && reuseIntervalError}
              label="Enter reuse interval (Days)"
              id="reuseInterval"
              name="reuseInterval"
              caption="Reuse interval"
              value={reuseIntervalValue}
              type="number"
              onBlur={handleBlur}
              onChange={handleChange}
              error={isReuseIntervalError}
            />
            <BaseCheckbox
              id="isDisabled"
              name="isDisabled"
              checked={isDisabledValue}
              title="Disabled"
              onChange={handleChange}
            />
            <BaseFieldArray
              fieldArrayName="levelRewards"
              items={levelRewardsValue ?? []}
              getBaseFieldValue={getRewardItem}
              selectSettings={{
                selectFields: { type: getRewardTypeSelectItems() },
              }}
              touched={touched}
              errors={errors}
              label="Level Reward"
              handleBlur={handleBlur}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
            />
          </FormBodyContainer>
        );
      }}
    </Formik>
  );
};
